module.exports = __webpack_public_path__ + "img/loopi_logo.112a6aea.png";